import { render, staticRenderFns } from "./taxonomy-category.vue?vue&type=template&id=5eec57f1&"
import script from "./taxonomy-category.vue?vue&type=script&lang=js&"
export * from "./taxonomy-category.vue?vue&type=script&lang=js&"
import style0 from "./taxonomy-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports